import {
  AllowedHttpMethods,
  employeeGeneralInformationApiConfig,
} from '../../apiList'
import {
  EmployeeGeneralInformation,
  EmployeeMandatoryInformation,
  VendorGeneralInformation,
} from '../../../../types/MyProfile/GeneralTab/generalInformationTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'

const getEmployeeGeneralInformation = async (
  employeeId: string,
): Promise<{ generalInformation: EmployeeGeneralInformation } | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeGeneralInformationApiConfig.getLoggedInEmployeeData,
    method: AllowedHttpMethods.get,
    params: {
      loggedInEmpId: employeeId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const getVendorGeneralInformation = async (
  vendorId: string,
): Promise<{ generalInformation: VendorGeneralInformation } | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeGeneralInformationApiConfig.getLoggedInVendorData || '',
    method: AllowedHttpMethods.get,
    params: {
      loggedInVendorId: vendorId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getOtherEmployeeGeneralInformation = async (
  employeeId: string,
): Promise<{ generalInformation: EmployeeGeneralInformation } | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeGeneralInformationApiConfig?.loggedInEmployeeData || '',
    method: AllowedHttpMethods.get,
    params: {
      loggedInEmpId: employeeId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getEmployeeBasicInfo = async (
  employeeId: string,
): Promise<
  { generalInformation: EmployeeMandatoryInformation } | undefined
> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeGeneralInformationApiConfig?.getEmployeeBasicInfo || '',
    method: AllowedHttpMethods.get,
    params: {
      empId: employeeId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const employeeGeneralInformationApi = {
  getEmployeeGeneralInformation,
  getOtherEmployeeGeneralInformation,
  getVendorGeneralInformation,
  getEmployeeBasicInfo,
}
export default employeeGeneralInformationApi
